(() => {
  if (window.__amcHomeCartController) return;
  window.__amcHomeCartController = true;

  const setButtonState = (button, loading) => {
    if (!button) return;
    button.toggleAttribute('aria-busy', loading);
    button.toggleAttribute('disabled', loading);
    button.classList.toggle('loading', loading);
    const label = button.querySelector('span');
    if (!label) return;
    if (!button.dataset.amcLabel) button.dataset.amcLabel = label.textContent.trim();
    label.textContent = loading ? 'Adding…' : button.dataset.amcLabel;
  };

  const showError = (form, message) => {
    let error = form.querySelector('.amc-home-cart-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'amc-home-cart-error';
      error.setAttribute('role', 'alert');
      form.prepend(error);
    }
    error.textContent = message;
    error.hidden = !message;
  };

  const initializeOptionForm = (form) => {
    if (form.dataset.amcOptionsReady === 'true') return;
    form.dataset.amcOptionsReady = 'true';
    const choices = [...form.querySelectorAll('[data-amc-option-choice]')];
    const variantInput = form.querySelector('[data-amc-option-variant-id]');
    const submit = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-amc-option-status]');
    const price = form.querySelector('[data-amc-option-price]');
    const gloveUnit = price ? price.querySelector('[data-amc-glove-unit]') : null;
    const gloveMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
    let variants = [];
    try { variants = JSON.parse(form.querySelector('[data-amc-option-variants]')?.textContent || '[]'); }
    catch (error) { variants = []; }
    // A field shown as a single fixed value follows the menus: once the chosen menu values leave only one
    // value for it (a pouch size that comes in one color, for example), that value is used and displayed.
    const fixedText = choices.map((choice) => choice.tagName === 'SELECT' ? null : choice.closest('.amc-home-option-field')?.querySelector('.amc-home-option-fixed') || null);
    const followMenus = () => {
      if (!fixedText.some(Boolean)) return;
      const chosen = choices.map((choice, index) => fixedText[index] ? '' : (choice.value || ''));
      const matching = variants.filter((candidate) => candidate.available && candidate.options?.every((value, index) => !chosen[index] || chosen[index] === value));
      choices.forEach((choice, index) => {
        if (!fixedText[index]) return;
        const values = [...new Set(matching.map((candidate) => candidate.options[index]))];
        if (values.length !== 1 || choice.value === values[0]) return;
        choice.value = values[0];
        fixedText[index].textContent = values[0];
      });
    };
    const sync = () => {
      followMenus();
      const selected = choices.map((choice) => choice.value || '');
      const complete = selected.every(Boolean);
      const variant = complete ? variants.find((candidate) => candidate.available && candidate.options?.every((value, index) => value === selected[index])) : null;
      if (variantInput) variantInput.value = variant?.id || '';
      if (submit) submit.disabled = !variant;
      if (price && gloveUnit) {
        price.hidden = false;
        const boxes = Number(gloveUnit.dataset.boxes);
        if (variant && boxes > 0) {
          gloveUnit.querySelector('.amc-glove-unit__box').textContent = gloveMoney(Math.round(variant.price / boxes)) + '/box';
          gloveUnit.querySelector('.amc-glove-unit__case').textContent = gloveMoney(variant.price) + ' per case';
          gloveUnit.dataset.caseCents = String(variant.price);
          gloveUnit.dataset.variantId = String(variant.id);
          const rawQuantity = Number(form.elements.quantity?.value || 1);
          const quantity = Number.isSafeInteger(rawQuantity) && rawQuantity > 0 ? rawQuantity : 1;
          if (form.elements.quantity) form.elements.quantity.setAttribute('aria-label', 'Quantity (cases)');
          const label = submit?.querySelector('span') || submit;
          if (label) label.textContent = 'Add ' + quantity + ' case' + (quantity === 1 ? '' : 's') + ' · ' + gloveMoney(variant.price * quantity);
        }
      } else if (price) {
        price.hidden = !variant;
        price.textContent = variant ? `Selected configuration: ${new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(variant.price / 100)}` : '';
      }
      if (status) {
        status.textContent = variant ? 'Options selected. Add to cart when ready.' : (complete ? 'That combination is unavailable. Choose another option.' : 'Choose each required option to continue.');
        status.classList.toggle('is-ready', Boolean(variant));
      }
    };
    choices.forEach((choice) => choice.addEventListener('change', sync));
    if (gloveUnit && form.elements.quantity) {
      form.elements.quantity.addEventListener('input', sync);
      form.elements.quantity.addEventListener('change', sync);
    }
    sync();
  };

  const initializeOptionForms = (root = document) => {
    if(root.matches?.('form[data-amc-home-option-form]'))initializeOptionForm(root);
    root.querySelectorAll?.('form[data-amc-home-option-form]').forEach(initializeOptionForm);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeOptionForms(), { once: true });
  else initializeOptionForms();
  document.addEventListener('shopify:section:load', (event) => initializeOptionForms(event.target));

  document.addEventListener('click', (event) => {
    const control = event.target.closest('.amc-card-qty button');
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const quantity = control.parentElement?.querySelector('input[type="number"]');
    if (!quantity) return;
    const minimum = Math.max(1, parseInt(quantity.min, 10) || 1);
    const maximum = quantity.max ? parseInt(quantity.max, 10) : Number.POSITIVE_INFINITY;
    const increment = Math.max(1, parseInt(quantity.step, 10) || 1);
    const current = Math.max(minimum, parseInt(quantity.value, 10) || minimum);
    const increase = control.getAttribute('aria-label')?.toLowerCase().includes('increase');
    quantity.value = String(Math.min(maximum, Math.max(minimum, current + (increase ? increment : -increment))));
    quantity.dispatchEvent(new Event('input', { bubbles: true }));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  // Never retry an uncertain add. The cart must be reviewed before adding again.
  let amcAdding = false;
  let amcReview = false;
  const cartUrl = () => (window.Shopify?.routes?.root || '/') + 'cart';
  function reviewRequired(value) {
    amcReview = value;
    try {
      if (value) sessionStorage.setItem('amc-add-review-required', String(Date.now()));
      else sessionStorage.removeItem('amc-add-review-required');
    } catch (_) {}
  }
  try {
    const last = document.referrer ? new URL(document.referrer) : null;
    if (last?.origin === window.location.origin && (last.pathname.endsWith('/cart') || last.pathname.endsWith('/cart/')))
      sessionStorage.removeItem('amc-add-review-required');
    amcReview = Boolean(sessionStorage.getItem('amc-add-review-required'));
  } catch (_) {}
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    try { amcReview = Boolean(sessionStorage.getItem('amc-add-review-required')); } catch (_) {}
  });
  const safeAddPath = window.Shopify?.routes?.root || '/';
  async function cartFetch(url, options = {}, duration = 16000) {
    const abort = new AbortController();
    const timer = setTimeout(() => abort.abort(), duration);
    try {
      const response = await fetch(url, {
        ...options,
        signal: abort.signal,
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {Accept: 'application/json', 'X-Requested-With':'XMLHttpRequest', ...(options.headers || {})}
      });
      let data;
      try { data = await response.json(); }
      catch (_) { throw new Error('Shopify cart response could not be confirmed.'); }
      return {response, data};
    } finally { clearTimeout(timer); }
  }
  const cartQuantity = (cart, id) =>
    Array.isArray(cart?.items) ? cart.items.filter(x => String(x.variant_id || x.id) === id)
      .reduce((n,x) => n + Number(x.quantity || 0),0) : null;
  function notice(form, drawer, heading, detail, isReview = true) {
    let host = drawer?.querySelector('.drawer__header') || drawer?.querySelector('.drawer__inner') || form;
    if (!drawer?.classList.contains('active')) host = form;
    let message = host.querySelector(':scope > .amc-cart-recovery');
    if (!message) {
      message = document.createElement('div');
      message.className = 'amc-cart-recovery';
      message.setAttribute('role','alert');
      message.tabIndex = -1;
      host.prepend(message);
    }
    message.replaceChildren();
    const title = document.createElement('strong');
    title.textContent = heading;
    const copy = document.createElement('p');
    copy.textContent = detail;
    message.append(title,copy);
    if (isReview) {
      const link = document.createElement('a');
      link.href = cartUrl();
      link.textContent = 'View cart';
      link.setAttribute('data-no-instant','');
      message.append(link);
    }
    message.focus({preventScroll:true});
  }
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-amc-home-cart-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (amcAdding || form.dataset.amcSubmitting === 'true') return;
    if (amcReview || form.dataset.amcReview === 'true') {
      window.location.assign(cartUrl());
      return;
    }
    if (!form.reportValidity()) return;
    const button = event.submitter || form.querySelector('button[type="submit"]');
    const drawer = document.querySelector('cart-drawer');
    const modal = form.closest('.amc-card-option-modal');
    const data = new FormData(form);
    const variant = String(data.get('id') || '');
    const quantity = Number(data.get('quantity') || 1);
    if (!/^\d+$/.test(variant) || !Number.isSafeInteger(quantity) || quantity < 1) {
      showError(form,'Select a valid product configuration and whole-number quantity.');
      return;
    }
    data.set('quantity', String(quantity));
    try {
      if (form.querySelector('[data-amc-cot-accessories]') && !window.amcAppendAccessoryItems) throw new Error('Accessory choices are still loading. Please try again.');
      window.amcAppendAccessoryItems?.(form, data);
    } catch (error) { showError(form,error.message); return; }
    const expected = new Map();
    for (const [key,id] of data.entries()) {
      const match=key.match(/^items\[(\d+)\]\[id\]$/);
      if(match) expected.set(String(id),(expected.get(String(id))||0)+Number(data.get(`items[${match[1]}][quantity]`)||1));
    }
    if(!expected.size) expected.set(variant,quantity);
    amcAdding = true;
    form.dataset.amcSubmitting = 'true';
    showError(form, '');
    setButtonState(button, true);
    let attempted = false, confirmed = false, rejected = false;
    let result = null, before = null, beforeCart = null;
    try {
      const beforeReply = await cartFetch(safeAddPath + 'cart.js');
      if (!beforeReply.response.ok || !Array.isArray(beforeReply.data?.items))
        throw new Error('Cart unavailable before submission. Nothing has been added.');
      before = cartQuantity(beforeReply.data, variant);
      beforeCart = beforeReply.data;
      data.set('sections', 'cart-drawer,cart-icon-bubble');
      data.set('sections_url', window.location.pathname + window.location.search);
      reviewRequired(true);
      attempted = true;
      try {
        const reply = await cartFetch(
          window.routes?.cart_add_url || safeAddPath + 'cart/add.js',
          {method:'POST',body:data}, 20000
        );
        if (!reply.response.ok || reply.data?.status) {
          rejected = [400,404,422].includes(reply.response.status);
          throw new Error(reply.data?.description || reply.data?.message || 'Cart addition not confirmed.');
        }
        result = reply.data;
        confirmed = true;
      } catch (error) {
        // Shopify may have accepted a POST even when its reply was lost.
        // Do not send another POST. Compare Shopify's actual cart state.
        let after = null, afterCart = null;
        try {
          const check = await cartFetch(safeAddPath + 'cart.js');
          if (check.response.ok) { after = cartQuantity(check.data,variant); afterCart = check.data; }
        } catch (_) {}
        if (beforeCart && afterCart && [...expected].every(([id,qty])=>cartQuantity(afterCart,id)-cartQuantity(beforeCart,id)>=qty)) {
          confirmed = true;
          result = {id:variant};
        } else if (rejected && beforeCart && afterCart && [...expected].every(([id])=>cartQuantity(afterCart,id)===cartQuantity(beforeCart,id))) {
          reviewRequired(false);
          throw error;
        } else {
          throw new Error('This request may have reached Shopify. Review your cart before adding again.');
        }
      }
      if (!drawer?.renderContents) {
        reviewRequired(false);
        window.location.assign(cartUrl());
        return;
      }
      try {
        let sections = result?.sections;
        if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble']) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections','cart-drawer,cart-icon-bubble');
          const response = await cartFetch(url.href);
          if (!response.response.ok) throw new Error('Drawer refresh unavailable');
          sections = response.data;
        }
        if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble'])
          throw new Error('Drawer refresh unavailable');
        // The add is already confirmed. Drawer errors must NOT become add errors.
        drawer.init?.();
        drawer.classList.remove('is-empty');
        drawer.renderContents({id:result?.id || variant,sections},true);
        modal?.hide?.(true);
        if(form.dataset.amcQuietCart!=='true')drawer.open?.(button);
        else if(form.amcOrigin){
          const origin=form.amcOrigin,label=origin.querySelector(':scope>span:not([aria-hidden])')||origin;
          label.textContent='Added to cart';origin.dataset.amcInstinctAdded='true';
          origin.setAttribute('aria-label','Added to cart. Add another if needed.');
          let status=origin.parentElement.querySelector('.amc-instinct-confirmation');
          if(!status){status=document.createElement('span');status.className='amc-instinct-confirmation';status.setAttribute('role','status');origin.after(status)}
          status.textContent='Added to cart.';
        }
        reviewRequired(false);
        form.dataset.amcReview = 'false';
        button?.classList.add('added-to-cart');
      } catch (_) {
        modal?.hide?.(true);
        form.dataset.amcReview = 'true';
        try { if(form.dataset.amcQuietCart!=='true')drawer.open?.(button); } catch (_) {}
        notice(form,drawer,'Your item was added.','The cart panel could not refresh. View your cart before adding this item again.');
      }
    } catch (error) {
      if (!attempted || (rejected && !amcReview)) {
        reviewRequired(false);
        showError(form,error.message || 'The item was not added. Check the configuration and try again.');
      } else {
        form.dataset.amcReview = 'true';
        notice(form,null,'Review your cart.','The request may have succeeded. Do not add the item again until you check your cart.');
      }
    } finally {
      drawer?.classList.remove('amc-cart-loading');
      amcAdding = false;
      form.dataset.amcSubmitting = 'false';
      setButtonState(button, false);
      if (amcReview && button) {
        const label = button.querySelector('span');
        if (label) label.textContent = 'View cart';
      }
      if (button) setTimeout(() => button.classList.remove('added-to-cart'),1200);
    }
  }, true);
})();
